import packageInfo from '@/../package.json';
import Link from 'next/link';

export default function Footer() {
	const version = packageInfo.version;
	return (
		<>
			<div className={`flex h-[40px] items-center justify-between gap-[20px] p-[2px_16px] text-[12px] text-white/70`}>
				<div>
					<div className={``}>Tralent © 2024</div>
				</div>
				<div>
					<nav className={`grid grid-flow-col gap-4`}>
						<div>
							<Link href={`/info/privacy`}>Privacy</Link>
						</div>
						<div>Version {version}</div>
					</nav>
				</div>
			</div>
		</>
	);
}
